import {makePostResendConfirmPhone} from 'main/factories/usecases';

export async function postResendPhoneOtpCode(phone: string) {
	return makePostResendConfirmPhone().post({
		celular: phone,
	});
}
